// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerPropertiesEditors.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Designer Properties Editors component
 */
!(function() {
  var m = require('mobx');

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var ReportsConstants = require('logic/data/Izenda.ReportsConstants');

  var PropertiesEditorTabsContainer = require('share/components/controls/Izenda.PropertiesEditorTabsContainer');
  var ReportDesignerWidget = require('share/components/hoc/Izenda.ReportDesignerWidget');
  var PropertiesEditorUtils = require('share/utils/Izenda.PropertiesEditorUtils');
  var PropertiesEditorManager = require('modules/Izenda.PropertiesEditorManager');

  var FilterPropsContainerSchema = require('./Fields/PropertiesBuilder/Izenda.FilterPropsContainerSchema');
  var ReportPartFieldPropsContainerSchema = require('./Fields//PropertiesBuilder/Izenda.ReportPartFieldPropsContainerSchema');
  var ReportPartPropsContainerSchema = require('./Fields/PropertiesBuilder/Izenda.ReportPartPropsContainerSchema');
  var ReportPartFormatPropsSchema = require('./Formats/Izenda.FormatItemSchema');
  const { get, getOr, isNil, concat } = require('lodash/fp');
  function getTabList(reportDesingerModel, fieldStore, props) {
    var context = this;
    props = props || {};
    var localization = props.localization;

    context.fieldEditor = context.fieldEditor || 'fieldProps';

    return {
      filterProps: {
        title: localization.getText('COMMON_LABEL_FILTER_PROPERTIES'),
        defaultSchema: FilterPropsContainerSchema
      },

      dataSourceFieldProps: {
        title: localization.getText('COMMON_LABEL_FIELD_PROPERTIES'),
        onRender: function() {
          context.fieldEditor = 'dataSourceFieldProps';
        },
        isShow: function() {
          return !props.dataSourceMode && context.fieldEditor === 'dataSourceFieldProps';
        }
      },

      fieldProps: {
        title: localization.getText('COMMON_LABEL_FIELD_PROPERTIES'),
        defaultSchema: ReportPartFieldPropsContainerSchema,
        onRender: function() {
          context.fieldEditor = 'fieldProps';
        },
        beforeRender: function(activeEditor, editorInfo) {
          // show backSide of config report part
          var reportBody = get('reportFields.reportBody', reportDesingerModel);
          var configReportPart = getOr({}, 'configReportPart', reportBody);

          !isNil(get('type', configReportPart)) && reportBody.changeReportPartSide(configReportPart, true);
        },

        isShow: function() {
          return !props.dataSourceMode && context.fieldEditor === 'fieldProps';
        }
      },

      reportPartProps: {
        title: localization.getText('REPORTDESIGNER_LABEL_REPORT_PART_PROPERTIES'),
        defaultSchema: ReportPartPropsContainerSchema,
        isShow: function() {
          return !props.dataSourceMode;
        }
      },

      formatItemProps: {
        title: localization.getText('REPORTDESIGNER_LABEL_FORMAT_PROPERTIES'),
        defaultSchema: ReportPartFormatPropsSchema,
        isShow: function() {
          return !props.dataSourceMode && (fieldStore.isVisibleHeaderFooter || fieldStore.isVisibleTitleDescription);
        }
      }
    };
  }

  var ReportDesignerPropertiesEditors = React.createClass({
    componentWillMount: function() {
      var props = this.props;
      var store = props.fieldStore;

      this.configReportPartId;

      // tracking - add new filter >> switch to filter tab (show filter editor)
      this.configFilterAction = m.reaction(function() {
        return get('reportFilters.newestFilter', store);
      }, switchToFilterTab);

      // tracking - add new element to report part >> switch to [report part field properties] tab (show report part field editor)
      this.configReportPartFieldAction = m.reaction(function() {
        return get('reportBody.configReportPart.newestField', store);
      }, switchToReportPartField.bind(this));

      function switchToFilterTab(newestFilter) {
        if (!newestFilter) {
          return;
        }

        var reportFilters = get('reportFilters', store);
        newestFilter = get('newestFilter', reportFilters);

        PropertiesEditorUtils.switchToEditor(
          null,
          {
            itemData: newestFilter,
            beforeShowProps: function() {
              reportFilters.setConfigModeToField(newestFilter);
            }
          },
          [{ name: 'filterProps' }]
        );
      }

      function switchToReportPartField(newestField) {
        if (!newestField) {
          return;
        }

        var configReportPart = getOr({}, 'reportBody.configReportPart', store);
        newestField = get('newestField', configReportPart);

        if (this.configReportPartId !== configReportPart.id) {
          this.configReportPartId = configReportPart.id;
          return;
        }

        PropertiesEditorUtils.switchToEditor(
          null,
          {
            itemData: newestField,
            beforeShowProps: function() {
              configReportPart && configReportPart.setConfigField(newestField);
            }
          },
          [
            {
              name: 'fieldProps',
              getDefinedSchema: ReportPartFieldPropsContainerSchema
            }
          ]
        );
      }
    },

    componentWillUnmount: function() {
      this.configFilterAction();
      this.configReportPartFieldAction();
    },

    render: function() {
      var props = this.props;

      var defaultParams = [props.reportDesignerModel, props.fieldStore];
      var tabList = getTabList.apply(this, concat(defaultParams, props));

      return (
        <PropertiesEditorTabsContainer
          className="horizontal-tabs"
          defaultParams={defaultParams}
          editors={tabList}
          onChangeActiveEditor={props.onActiveEditor}
        />
      );
    }
  });

  module.exports = connect()(ReportDesignerPropertiesEditors);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Izenda.ReportDesignerPropertiesEditors.jsx